import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import { RootStore } from './RootStore';

export function useStores() {
  return useContext<RootStore>(MobXProviderContext as any);
}


